import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/newPhone/liveGuided.svg'
import _imports_1 from '../../assets/liveGuide/webguide.svg'


const _withScopeId = n => (_pushScopeId("data-v-07ae9c1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap mod_wrap mod_set_wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav mod_c_title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "直播引导页")
], -1))
const _hoisted_3 = {
  key: 1,
  class: "community"
}
const _hoisted_4 = { class: "picture" }
const _hoisted_5 = { class: "picture_lef" }
const _hoisted_6 = {
  key: 0,
  class: "picture_img"
}
const _hoisted_7 = { class: "play_interface" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"300px"}
}, null, -1))
const _hoisted_9 = { class: "picture_imgg" }
const _hoisted_10 = { class: "cv_title" }
const _hoisted_11 = { class: "cv_title_span" }
const _hoisted_12 = {
  key: 0,
  class: "move_box"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 2,
  class: "cv_img_box"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 3,
  class: "cv_img_box"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 1,
  class: "picture_img_web"
}
const _hoisted_21 = { class: "play_interface_web" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"432px"}
}, null, -1))
const _hoisted_23 = { class: "pc_title" }
const _hoisted_24 = { class: "cv_title_span" }
const _hoisted_25 = { class: "bg_div_color" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "container container_magazine" }
const _hoisted_28 = { class: "container_rig" }
const _hoisted_29 = {
  key: 0,
  class: "container_rig_one mar_top"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mar_title" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fff","margin":"0"} }),
  /*#__PURE__*/_createTextVNode("移动端引导页：")
], -1))
const _hoisted_31 = {
  key: 1,
  class: "container_rig_one mar_top"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mar_title" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fff","margin":"0"} }),
  /*#__PURE__*/_createTextVNode("Web端引导页：")
], -1))
const _hoisted_33 = {
  key: 2,
  class: "container_rig_one mar_top"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mar_title" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fff","margin":"0"} }),
  /*#__PURE__*/_createTextVNode("强制关注公众号：")
], -1))
const _hoisted_35 = {
  key: 3,
  class: "container_rig_one mar_top"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mar_title" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fff","margin":"0"} }),
  /*#__PURE__*/_createTextVNode("强制关注公众号：")
], -1))
const _hoisted_37 = {
  key: 4,
  class: "container_rig_one mar_top"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mar_title" }, "模式选择：", -1))
const _hoisted_39 = {
  key: 5,
  class: "container_rig_two"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"80px"},
  class: "mar_title"
}, "活动杂志：", -1))
const _hoisted_41 = {
  key: 6,
  class: "container_rig_three"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"80px"},
  class: "mar_title"
}, "活动海报：", -1))
const _hoisted_43 = {
  key: 0,
  class: "rich_text_box"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "内容编辑：", -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  key: 1,
  class: "tinyMce"
}
const _hoisted_47 = {
  key: 2,
  class: "setUp"
}
const _hoisted_48 = { class: "PCbgcolor" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "背景颜色：", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rich_text_box" }, [
  /*#__PURE__*/_createElementVNode("span", null, "内容编辑：")
], -1))
const _hoisted_51 = { class: "tinyMce" }
const _hoisted_52 = { class: "save_box" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "save_box" }, null, -1))

import Crumb from '@/components/Crumb.vue';
import CUpload from '@/components/CUpload.vue';
import { computed, onBeforeUnmount, onMounted, ref, inject, unref } from 'vue';
import { CloseOutlined, EllipsisOutlined } from '@ant-design/icons-vue';
import { Radio, message, Tabs } from 'ant-design-vue';
import { ElColorPicker } from 'element-plus';
import http from '@/api/live';
import httpsave from '@/api/guidePage';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import router from '@/router';
import tinymce from 'tinymce/tinymce';
import Editor from '@tinymce/tinymce-vue';
import { init, apikey } from '@/components/CTinymce';
import { LiveInfo } from '@/store/modules/live/types';
import CLoading from '@/components/CLoading.vue';
import { useHomeStore } from '@/pinia/home';

interface liveInfoType {
  guide_status: number;
  guide_pc_status: number;
  guide_mode: number;
  guide_bg_image: string; //id
  guide_bg_image_url: string; //海报
  guide_pc_bg_color: string;
  guide_content: string;
  title: string;
  guide_pc_content: string;
  image_guide_url: string; //杂志
  // image: string;
}
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: any;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

const __default__ = { name: 'LiveGuide' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const liveInfoData = computed(() => unref(inject('liveInfo')) as LiveInfo);
const aRadioGroup = Radio.Group;
const aTabs = Tabs;
const aTabPane = Tabs.TabPane;
const liveBroadcastingRoomId = router.currentRoute.value.params.studioId;
const moblie_web = ref(0);
const checkedSave = ref<boolean>(false); //总开关
const checkedWeb = ref<boolean>(false); //web引导页开关
  const homeStore = useHomeStore();
/**
 * @description mm类
 * @guide_status id
 */
const liveInfo = ref<liveInfoType>({
  guide_status: 0, //开关
  guide_pc_status: 0, // pc 开关
  guide_mode: 1, //杂志or海报 选择器
  guide_bg_image: '', //id
  guide_bg_image_url: '', //海报 图片地址
  guide_pc_bg_color: '', // pc 背景色
  guide_content: '', // 富文本
  title: '测试直播间', // pc title
  guide_pc_content: '', // pc 富文本
  image_guide_url: '', //杂志 图片地址
  // image: '',
});

const guide_pc_subscribe = ref(false);
const guide_subscribe = ref(false);

const showLoading = ref(false);
const getLiveView = () => {
  showLoading.value = true;
  const data = {
    studio_id: liveBroadcastingRoomId,
  };
  http
    .getLiveView({ params: data })
    .then((res) => {
      liveInfo.value = res.data.data;
      tinyMceValue.value = liveInfo.value.guide_content;
      pcTinyMceValue.value = liveInfo.value.guide_pc_content;
      liveInfo.value.guide_mode = res.data.data.guide_mode ?? 1;
      checkedWeb.value = liveInfo.value.guide_pc_status ? true : false;
      checkedSave.value = liveInfo.value.guide_status ? true : false;
      colour.value = liveInfo.value.guide_pc_bg_color ? liveInfo.value.guide_pc_bg_color : colour.value;
      showLoading.value = false;
      guide_pc_subscribe.value = Boolean(res.data.data.guide_pc_subscribe);
      guide_subscribe.value = Boolean(res.data.data.guide_subscribe);
    })
    .catch((res) => {
      message.error(res.data.error);
      showLoading.value = false;
    });
};
getLiveView();
// 保存数据
const saveGuide = useDebounce(() => {
  const data = {
    studio_id: liveBroadcastingRoomId,
    status: checkedSave.value === true ? 1 : 0,
    pc_status: checkedWeb.value === true ? 1 : 0,
    mode: liveInfo.value.guide_mode,
    pc_title: liveInfo.value.title,
    image: image_guide_url_id.value ? image_guide_url_id.value : '',
    bg_image: liveInfo.value.guide_bg_image,
    pc_bg_color: colour.value,
    content: tinyMceValue.value,
    pc_content: pcTinyMceValue.value,
    pc_subscribe: guide_pc_subscribe.value ? 1 : 0,
    subscribe: guide_subscribe.value ? 1 : 0,
  };
  httpsave
    .saveGuide(data)
    .then((res) => {
      message.destroy();
      message.success(res.data.message);
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
});
const colorList = ref(['#00ccb0', '#1890FF', '#FF4D4F', '#FF9337']);
const color = ref(colorList.value[0]);
const colour = ref('#d5d5d5');
// 重置
const reset = useDebounce(() => {
  color.value = colorList.value[0];
  colour.value = '#d5d5d5';
});
//图片上传
const loadingo = ref<boolean>(false);
const loadingi = ref<boolean>(false);
const fileList = ref();
const image_guide_url_id = ref();
const handleChange = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    if (liveInfo.value.guide_mode === 0) {
      liveInfo.value.image_guide_url = info.file?.response?.data.url;
      image_guide_url_id.value = info.file?.response?.data.id;
    } else if (liveInfo.value.guide_mode === 1) {
      liveInfo.value.guide_bg_image_url = info.file?.response?.data.url;
      liveInfo.value.guide_bg_image = info.file?.response?.data.id;
    }
  }
  if (info.file.status === 'uploading' && liveInfo.value.guide_mode === 0) {
    loadingo.value = true;
    return;
  } else loadingo.value = false;
  if (info.file.status === 'uploading' && liveInfo.value.guide_mode === 1) {
    loadingi.value = true;
    return;
  } else loadingi.value = false;
};
const imgDel = () => {
  if (liveInfo.value.guide_mode === 0) {
    liveInfo.value.image_guide_url = '';
    image_guide_url_id.value = '';
  } else if (liveInfo.value.guide_mode === 1) {
    liveInfo.value.guide_bg_image_url = '';
    liveInfo.value.guide_bg_image = '';
  }
};
(info: FileInfo) => handleChange(info);

// 富文本key
const pcTinyMceValue = ref();
const tinyMceValue = ref();

onMounted(() => {
  tinymce.init({});
});
onBeforeUnmount(() => {
  tinymce.remove();
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_radio = _resolveComponent("a-radio")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_unref(aTabs), {
        activeKey: moblie_web.value,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((moblie_web).value = $event)),
        type: "card"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_unref(aTabPane), {
            key: 0,
            tab: "移动端引导页"
          })),
          (_openBlock(), _createBlock(_unref(aTabPane), {
            key: 1,
            tab: "Web端引导页",
            "force-render": ""
          }))
        ]),
        _: 1
      }, 8, ["activeKey"]),
      (showLoading.value)
        ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("ul", _hoisted_5, [
                (moblie_web.value === 0)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_unref(CloseOutlined), { style: {"color":"#3f3f3f"} }),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(liveInfo.value.title), 1),
                            _createVNode(_unref(EllipsisOutlined), { style: {"color":"#3f3f3f","font-size":"16px"} })
                          ]),
                          (liveInfo.value.guide_mode === 0 && liveInfo.value.image_guide_url)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("img", {
                                  class: "picture_imgg_img",
                                  src: liveInfo.value.image_guide_url
                                }, null, 8, _hoisted_13)
                              ]))
                            : _createCommentVNode("", true),
                          (liveInfo.value.guide_mode === 1 && liveInfo.value.guide_bg_image_url)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                class: "imgmessage",
                                src: liveInfo.value.guide_bg_image_url
                              }, null, 8, _hoisted_14))
                            : _createCommentVNode("", true),
                          (liveInfo.value.guide_mode === 1 && !liveInfo.value.guide_bg_image_url)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("img", {
                                  class: "picture_imgg_img",
                                  src: _unref(liveInfoData).image_player_cover_url
                                }, null, 8, _hoisted_16)
                              ]))
                            : _createCommentVNode("", true),
                          (liveInfo.value.guide_mode === 0 && !liveInfo.value.image_guide_url)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("img", {
                                  class: "picture_imgg_img",
                                  src: _unref(liveInfoData).image_player_cover_url
                                }, null, 8, _hoisted_18)
                              ]))
                            : _createCommentVNode("", true),
                          (liveInfo.value.guide_mode === 0 && moblie_web.value === 0)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 4,
                                class: "picture_imgg_html",
                                innerHTML: tinyMceValue.value
                              }, null, 8, _hoisted_19))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_a_button, {
                          type: "primary",
                          shape: "round",
                          size: "",
                          class: "cv_in_room"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("进入直播")
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (moblie_web.value === 1)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", {
                          class: "web_bg_color",
                          style: _normalizeStyle({ background: colour.value })
                        }, null, 4),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(liveInfo.value.title), 1)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", { innerHTML: pcTinyMceValue.value }, null, 8, _hoisted_26)
                        ]),
                        _createVNode(_component_a_button, {
                          type: "primary",
                          shape: "round",
                          size: "mini",
                          class: "cv_in_room_web"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("进入直播")
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("ul", _hoisted_28, [
                (moblie_web.value === 0)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                      _hoisted_30,
                      _createVNode(_component_a_switch, {
                        checked: checkedSave.value,
                        "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((checkedSave).value = $event)),
                        onChange: _unref(saveGuide)
                      }, null, 8, ["checked", "onChange"])
                    ]))
                  : _createCommentVNode("", true),
                (moblie_web.value === 1)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                      _hoisted_32,
                      _createVNode(_component_a_switch, {
                        checked: checkedWeb.value,
                        "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((checkedWeb).value = $event)),
                        onChange: _unref(saveGuide)
                      }, null, 8, ["checked", "onChange"])
                    ]))
                  : _createCommentVNode("", true),
                (moblie_web.value === 0 && _unref(homeStore).funcData?.AccountState )
                  ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                      _hoisted_34,
                      _createVNode(_component_a_switch, {
                        checked: guide_subscribe.value,
                        "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((guide_subscribe).value = $event))
                      }, null, 8, ["checked"])
                    ]))
                  : _createCommentVNode("", true),
                (moblie_web.value === 1 && _unref(homeStore).funcData?.AccountState )
                  ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                      _hoisted_36,
                      _createVNode(_component_a_switch, {
                        checked: guide_pc_subscribe.value,
                        "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((guide_pc_subscribe).value = $event))
                      }, null, 8, ["checked"])
                    ]))
                  : _createCommentVNode("", true),
                (moblie_web.value === 0)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                      _hoisted_38,
                      _createVNode(_unref(aRadioGroup), {
                        value: liveInfo.value.guide_mode,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((liveInfo.value.guide_mode) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, { value: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode("杂志模式")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("海报模式")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]))
                  : _createCommentVNode("", true),
                (liveInfo.value.guide_mode === 0 && moblie_web.value === 0)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                      _hoisted_40,
                      _createVNode(CUpload, {
                        "file-list": fileList.value,
                        "handle-change": handleChange,
                        loading: loadingo.value,
                        "image-name": liveInfo.value.image_guide_url,
                        "click-stop": imgDel,
                        class: "ant_upload"
                      }, null, 8, ["file-list", "loading", "image-name"])
                    ]))
                  : _createCommentVNode("", true),
                (liveInfo.value.guide_mode === 1 && moblie_web.value === 0)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                      _hoisted_42,
                      _createVNode(CUpload, {
                        "handle-change": handleChange,
                        loading: loadingi.value,
                        "image-name": liveInfo.value.guide_bg_image_url,
                        "click-stop": imgDel,
                        class: "ant_upload_img"
                      }, null, 8, ["loading", "image-name"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (liveInfo.value.guide_mode === 0 && moblie_web.value === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
                : _createCommentVNode("", true),
              (liveInfo.value.guide_mode === 0 && moblie_web.value === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createVNode(_unref(Editor), {
                      modelValue: tinyMceValue.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((tinyMceValue).value = $event)),
                      "api-key": _unref(apikey),
                      init: _unref(init)
                    }, null, 8, ["modelValue", "api-key", "init"])
                  ]))
                : _createCommentVNode("", true),
              (moblie_web.value === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_48, [
                        _hoisted_49,
                        _createElementVNode("div", null, [
                          _createElementVNode("span", null, _toDisplayString(colour.value), 1),
                          _createVNode(_unref(ElColorPicker), {
                            modelValue: colour.value,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((colour).value = $event)),
                            size: "mini",
                            predefine: colorList.value
                          }, null, 8, ["modelValue", "predefine"])
                        ]),
                        _createVNode(_component_a_button, {
                          class: "reset_but",
                          onClick: _unref(reset)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("重置")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _hoisted_50
                    ])
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_51, [
                _createVNode(_unref(Editor), {
                  modelValue: pcTinyMceValue.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((pcTinyMceValue).value = $event)),
                  "api-key": _unref(apikey),
                  init: _unref(init)
                }, null, 8, ["modelValue", "api-key", "init"])
              ], 512), [
                [_vShow, moblie_web.value === 1]
              ]),
              _createElementVNode("div", _hoisted_52, [
                (moblie_web.value === 1)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      class: "rich_text_savebut",
                      onClick: _unref(saveGuide)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("保存")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (liveInfo.value.guide_mode === 0 && moblie_web.value === 0)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      type: "primary",
                      class: "rich_text_savebut",
                      onClick: _unref(saveGuide)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("保存")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (liveInfo.value.guide_mode === 1 && moblie_web.value === 0)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 2,
                      type: "primary",
                      class: "rich_text_savebut",
                      onClick: _unref(saveGuide)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("保存")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])),
      _hoisted_53
    ])
  ], 64))
}
}

})